{
	"dist_folder": "public",
	"static_folder": "static",
	"repo_name": "schloss-freudenfels",
	"preview_document_id_cookie": "io.prismic.preview.documentId",
	"domain": "https://www.schloss-freudenfels.ch"
}
